import { HttpErrorResponse } from '@angular/common/http';

import {
  BillingEstimate,
  BillingEstimateParams,
  BillingEstimateSlotsParams,
} from '@recruitee/http/types';
import { createSingleEntityStore, PickActions, pipeState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<BillingEstimate>()(
  'BillingEstimate',
  {
    customActions: adapter => ({
      fetch: (state, payload: BillingEstimateParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),

      fetchSlots: (state, payload: BillingEstimateSlotsParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),
      fetchSlotsSuccess: (state, payload: { data: any }) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      fetchSlotsFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(adapter.reset(), next => adapter.setError(next, payload.error)),
    }),
  },
);

const BillingEstimateActions: PickActions<typeof actions, 'fetch' | 'fetchSlots'> = actions;

export {
  BillingEstimateActions,
  namespace as BillingEstimateNamespace,
  reducer as BillingEstimateReducer,
  selectors as BillingEstimateSelectors,
};
